<div class="h-100 d-flex align-items-center action-container" *appHasRole="['Admin']">
  @if (isUserRecord) {
    <app-ag-action-icon-button
      iconClass="ic-edit-16"
      tooltipText="Edit"
      (action)="onEdit()"
    />

    <app-ag-action-icon-button
      iconClass="ic-key-16"
      tooltipText="Reset MFA"
      (action)="onResetMFA()"
    />

    <app-ag-action-icon-button
      iconClass="ic-lock-16"
      tooltipText="Reset Password"
      (action)="onResetPassword()"
    />
  }

  <app-ag-action-icon-button
    iconClass="ic-trash-16"
    tooltipText="Delete"
    (action)="onDelete()"
  />
</div>
